import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'epay-howtos',
  templateUrl: './howtos.component.html'
})
export class HowTosComponent implements OnInit {

  pagetitle = 'Missouri Child Support Website Help';
  constructor() { }

  ngOnInit(): void {
  }

}
